import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class Description extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {

    return (
      <div className="margin-top-20">
        <p className="cuote text-center margin-0"><i>{this.props.quote}</i></p>
        <p className="text-center"><i>{this.props.autor}</i></p>
        <p dangerouslySetInnerHTML={{__html: this.props.content}}></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/Description.jsx